import { throttle } from 'radash';
import { useState, useEffect } from 'react';
import { useGlobal } from './global';

let i = 0;

export const useItems = (jobId, limit = 50, offset = 0) => {
  const { fox } = useGlobal();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!fox || !jobId) {
      return;
    }

    const update_ = () =>
      fox.items(jobId, { limit, offset }).then((items_) => {
        setLoading(false);
        setItems(items_);
      });

    // const msec = 1000;
    // const update = throttle({ interval: msec }, () => {
    //   update_();
    //   setTimeout(update_, msec);
    // });

    const job = new fox.Job(jobId);
    job.on('finished', update_);
    job.on('update', update_);
    setLoading(true);
    update_();

    return () => {
      job.off('finished', update_);
      job.off('update', update_);
    };
  }, [fox, jobId, limit, offset]);

  return { loading, items };
};
